// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Box, Breadcrumbs, Container, Skeleton, Stack } from '@mui/material';

export function ShipmentDetailsSkeleton() {
  return (
    <Container maxWidth="xl">
      {/* Breadcrumbs */}
      <Stack marginTop={3} paddingX={3}>
        <Breadcrumbs separator="›">
          <Skeleton variant="text" width={80} />
          <Skeleton variant="text" width={100} />
        </Breadcrumbs>
      </Stack>

      {/* Header */}
      <Stack paddingX={{ xs: 1, md: 3 }} spacing={1} marginTop={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Skeleton variant="text" width={120} height={40} />
            <Skeleton variant="rounded" width={80} height={24} />
          </Stack>
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rectangular" width={80} height={36} />
            <Skeleton variant="rectangular" width={120} height={36} />
            <Skeleton variant="rectangular" width={120} height={36} />
          </Stack>
        </Stack>
      </Stack>

      {/* Main content */}
      <Box
        sx={{
          alignItems: 'flex-start',
          display: 'grid',
          gap: 2,
          gridTemplateAreas: {
            xs: `
              "phase"
              "lineItems"
              "tracking"
              "notes"
            `,
            sm: `
              "phase phase"
              "lineItems lineItems"
              "tracking notes"
            `,
            md: `
              "phase tracking"
              "lineItems notes"
            `,
          },
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            sm: 'minmax(0, 1fr) minmax(0, 1fr)',
            md: 'minmax(0, 7fr) minmax(0, 360px)',
          },
          marginY: 3,
          paddingX: { xs: 1, md: 3 },
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height={260}
          sx={{ gridArea: 'phase' }}
        />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={260}
          sx={{ gridArea: 'lineItems' }}
        />
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ gridArea: 'tracking', minHeight: 260 }}
        />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={240}
          sx={{ gridArea: 'notes' }}
        />
      </Box>
    </Container>
  );
}
